import React from 'react';

/**
 * PersonSchema Component - For Jo Day (Founder)
 * CRITICAL for E-E-A-T (Experience, Expertise, Authoritativeness, Trustworthiness)
 * This tells Google/AI that a real expert is behind the content
 * Helps with "Who founded Audio & Co?" voice queries
 * 
 * IMPORTANT: Renders inline so Google can see it on first crawl
 */
const PersonSchema = () => {
  const personSchema = {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": "https://audioandco.com/#founder",
    "name": "Jo Day",
    "givenName": "Jo",
    "familyName": "Day",
    "jobTitle": "Founder",
    "description": "Jo Day is the founder of Audio & Co®, a media production company specializing in podcast production, book publishing, and mobile app development. She has trained over 120 business owners in podcast launch and management, formatted books for over 400 authors, and is herself a 6x Amazon bestselling author.",
    "url": "https://audioandco.com/about",
    "image": "https://audioandco.com/images/jo-day.jpg",
    "sameAs": [
      "https://www.linkedin.com/in/joday",
      "https://twitter.com/audioandco",
      "https://www.instagram.com/audioandco"
    ],
    "worksFor": {
      "@id": "https://audioandco.com/#organization"
    },
    "knowsAbout": [
      "Podcast Production",
      "Self-Publishing",
      "Audiobook Production",
      "Business Coaching",
      "Content Marketing",
      "DMAIC Methodology",
      "Lean Six Sigma",
      "Small Business Operations"
    ],
    "hasCredential": [
      {
        "@type": "EducationalOccupationalCredential",
        "credentialCategory": "certification",
        "name": "DMAIC Certified"
      }
    ],
    "award": [
      "6x Amazon Bestselling Author",
      "Published 400+ books for clients",
      "Trained 120+ business owners in podcasting"
    ],
    "alumniOf": {
      "@type": "Organization",
      "name": "Small Business Owner since 2010"
    }
  };

  return (
    <script
      type="application/ld+json"
      data-schema="person"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(personSchema) }}
    />
  );
};

export default PersonSchema;
